import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../tools/LanguageContext";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import MediaImage from "../tools/Media"

function ArticleAnalysis() {
  const { translations, language } = useLanguage();
  const { articleId } = useParams(); // Λαμβάνουμε το articleId από το URL
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Αρχικοποίηση του AOS
    AOS.init({
      duration: 1000,
    });

    const url = language === "en"
    ? `https://artofbetting.gr/api/articles/${articleId}?lang=en`
    : `https://artofbetting.gr/api/articles/${articleId}`;

    // Κάνουμε το αίτημα για το συγκεκριμένο άρθρο
    axios
      .get(url)
      .then((response) => {
        setArticle(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error fetching the article:", error);
      });

  }, [articleId, language]);

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4 w-full max-w-screen overflow-x-hidden">
      {/* Header */}
      <header className="flex justify-between items-center p-4 bg-gray-800 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
            <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
              {translations.home}
            </button>
          </Link>
        </nav>
      </header>

      {/* Content */}
      <main className="mt-6">
        {loading ? (
          <div className="text-center bg-green-800 p-4 rounded-lg">
            <p>{translations.loading}</p>
          </div>
        ) : (
          article && (
            <div className="bg-gray-800 p-4 rounded-lg shadow-lg">
              <div className="text-left">
                <h2 className="text-3xl font-bold mb-4">{article.title}</h2>
                <p className="text-gray-400 mb-4">
                  {article.writer === "mrarber" ? translations.mrArber :
                    article.writer === "vretanos" ? translations.vretanos :
                    article.writer === "nole" ? translations.nole : ""} - {new Date(article.date).toLocaleDateString("el-GR")}
                </p>
                {article.photo && (
                  <MediaImage media={'/article'+article.photo} />
                )}
                <div className="mt-6 mb-4">
                  <p style={{ whiteSpace: 'pre-line' }}>{article.details}</p>
                </div>
              </div>
            </div>
          )
        )}
      </main>

      {/* Footer */}
      <footer className="relative w-full bg-gray-900 py-8">
        <div className="flex flex-col items-center justify-between w-full">
          <p className="text-xl font-bold border-b border-t p-4 mb-8">© Copyright 2025 Art Of Betting</p>
          <p className="text-lg font-bold border-b border-t p-2 mb-8 text-center">
            <span className="font-semibold">Διαφημιστειτε εδώ:</span>{' '}
            <a href="mailto:artofbetting2025@gmail.com" className="hover:underline">
              artofbetting2025@gmail.com
            </a>
          </p>

          <div className="flex items-center justify-between w-2/5 mb-8">
            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-1/5 mr-8">
              <img
                src="../images/21.svg"
                alt="21+"
                className="w-full h-auto"
              />
            </a>

            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-4/5">
              <img
                src="../images/kethea.svg"
                alt="kethea"
                className="w-full h-auto"
              />
            </a>
          </div>

          <a href="https://certifications.gamingcommission.gov.gr/publicRecordsOnline/SitePages/AffiliatesOnline.aspx" target="_blank" rel="noopener noreferrer">
            <img
              src="../images/eeep.png"
              alt="eeep"
              className="w-full h-auto border-b border-t p-4"
            />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default ArticleAnalysis;
